import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Drawer from "@material-ui/core/Drawer"

import MenuIcon from "@material-ui/icons/Menu"
// import Menu from "../Menu/Menu"
import MobileMenu from "../MobileMenu/MobileMenu"

import { Link } from "gatsby"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
// import logo2 from "../../assets/images/prodhost.png"
import szechenyi_logo from "../../assets/images/szechenyi_mobile.png"

import SearchIcon from "@material-ui/icons/Search"
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer"

import "./mobileHeader.scss"

const useStyles = makeStyles({
  list: {
    width: 350,
    height: "100vh",
    maxHeight: "calc(100% - 57px)",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#1E1E1E",
    color: "white",
  },
  link: {
    color: "white",
    border: 0,
  },
  linkButton: {
    color: "white",
    height: 50,
  },
  list2: {
    color: "rgb(203, 219, 231)",
  },
})

export default function TemporaryDrawer(props) {
  const classes = useStyles()
  const [state, setState] = React.useState({
    left: false,
  })
  // const [open, setOpen] = React.useState(true)

  // const handleClick = () => {
  //   setOpen(!open)
  // }

  // const [language, setLanguage] = useState("hu")

  // const handleClick = (lang) => {
  //   setLanguage(lang)
  //   // i18n.changeLanguage(lang)
  // }

  const toggleDrawer = (side, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }

    setState({ ...state, [side]: open })
  }

  const sideList = (side) => (
    <div
      className={classes.list}
      role="presentation"
      // onClick={toggleDrawer(side, false)}
      // onKeyDown={toggleDrawer(side, false)}
    >
      <div className="contact-wrapper">
        <div className="search-icon">
          <SearchIcon style={{ color: "white" }} />
        </div>
        <Link to="/contact-us">
          <div className="contact-button" style={{ color: "white" }}>
            <QuestionAnswerIcon />
            <span>Kapcsolat</span>
          </div>
        </Link>
      </div>
      <MobileMenu items={props.items} />
    </div>
  )

  return (
    <AppBar className="header-mobile">
      <MenuIcon
        className="hamburger-menu"
        onClick={toggleDrawer("left", true)}
      />
      <Toolbar>
        <Link to="/" className="prodhost_logo_wrapper">
          <img
            src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${props.logo.path}`}
            alt="prodhost-mobile-header-logo"
            aria-label="prodhost-mobile-header-logo"
            className="header-logo"
          />
        </Link>
        <Drawer open={state.left} onClose={toggleDrawer("left", false)}>
          {sideList("left")}
        </Drawer>
        {/* {props.logo ? ( */}
        <Link to="/szechenyi-2020" className="szechenyi_logo_wrapper">
          <img
            className="szechenyi_logo"
            src={szechenyi_logo}
            alt="szechenyi_logo_mobile"
            aria-label="szechenyi_logo_mobile"
          />
        </Link>
        {/* ) : null} */}
      </Toolbar>
    </AppBar>
  )
}
